import { useEffect } from "react"
import { usePlan } from "../lib/usePlan"
import { usePlanActions } from "../lib/usePlanActions"
import { useAuth } from "@/features/Auth/lib/useAuth"

function PlanInitializer() {
  const { getMyPlans, getPlanTypes, getMyMyltyPlans } = usePlanActions()
  const { loading, error } = usePlan() 
  const { isAuth } = useAuth();

  useEffect(() => {
    if(isAuth && !loading.myPlans && !error.myPlans){
      getMyPlans();
    }
    if(isAuth && !loading.planTypes && !error.planTypes){
      getPlanTypes();
    }
    if(isAuth && !loading.myMultyPlans && !error.myMultyPlans){
      getMyMyltyPlans();
    }
    //eslint-disable-next-line
  },[isAuth]);

  return null;
}

export default PlanInitializer